import React from "react"
import autobind from "class-autobind"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import Table from "../common/Table"
import strings from "../../localization/strings"
import { IQuestionTableItem } from "../../models"
import ReOrder from "material-ui/svg-icons/action/reorder"
import QuestionDragDropRow from "./QuestionDragDropRow"
import _ from "lodash"
interface IProps {
    readonly: boolean
    punchIn: boolean
    questionTableItems: IQuestionTableItem[]
    selectedGroupIds: number[]
    handleSelectQuestions(selectedQuestionGroupIds: number[]): void
    handleUpdateQuestion(updateQuestionGroupId: number): void
    handleReoderQuesetions(groupIdOrder: number[]): void
}
interface IState {
    dragDropRowGroupId: number
    questionTableItems: IQuestionTableItem[]
}

export default class PunchQuestionBodyTable extends React.Component<IProps, IState>  {
    private prefix = `question_${this.props.punchIn ? "PunchIn" : "PunchOut"}_table`
    constructor(props: IProps) {
        super(props)
        this.state = {
            dragDropRowGroupId: null,
            questionTableItems: props.questionTableItems
        }
        autobind(this)
    }
    componentDidMount() {
        this.renderDragIcon()
    }

    componentDidUpdate() {
        this.renderDragIcon()
    }

    componentWillReceiveProps(nextProps: IProps) {
        !_.isEqual(this.props.questionTableItems, nextProps.questionTableItems) &&
            this.setState({ questionTableItems: nextProps.questionTableItems })
    }

    renderDragIcon() {
        if (this.props.readonly || this.state.questionTableItems.length < 2) return
        if (!document.getElementById(`${this.prefix}_header_row`)) return

        const checkBoxHeaderCol = document.getElementById(`${this.prefix}_header_row`).firstElementChild
        const dragDropIconHeaderCol = document.getElementById(`${this.prefix}_dragdrop_icon_header`)
        dragDropIconHeaderCol.insertAdjacentElement("afterend", checkBoxHeaderCol)

        this.state.questionTableItems.forEach(row => {
            const checkBoxCol = document.getElementById(`${this.prefix}_row_${row && row.GroupId}`).firstElementChild
            const dragDropIconCol = document.getElementById(`${this.prefix}_row_dragdrop_icon_${row && row.GroupId}`)
            dragDropIconCol.insertAdjacentElement("afterend", checkBoxCol)
        })
    }

    render() {
        return (
            <div>
                <Table
                    readonly={this.props.readonly}
                    allowClickRow
                    items={this.state.questionTableItems}
                    selectedItems={this.state.questionTableItems.filter(i => this.props.selectedGroupIds.includes(i.GroupId))}
                    handleSelect={selectedRows => this.props.handleSelectQuestions(selectedRows.map(i => i.GroupId))}
                    handleClickRow={clickedRow => this.props.handleUpdateQuestion(clickedRow.GroupId)}
                >
                    <TableHeader>
                        <TableRow id={`${this.prefix}_header_row`}>
                            {!this.props.readonly && this.state.questionTableItems.length > 1 &&
                                <TableHeaderColumn id={`${this.prefix}_dragdrop_icon_header`} style={{ paddingLeft: 3, paddingRight: 0, width: 25 }} />
                            }
                            <TableHeaderColumn style={styles.orderCol}>{strings.Order}</TableHeaderColumn>
                            <TableHeaderColumn style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
                            <TableHeaderColumn style={styles.dateCol}>{strings.Modified_Date}</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody deselectOnClickaway={false}>
                        {this.state.questionTableItems.map((row, index) => {
                            return (
                                <TableRow
                                    data-intercom-target={index === 0 && (this.props.punchIn ? "PunchInQuestionsRow-OpenItemDetails" : "PunchOutQuestionsRow-OpenItemDetails")}
                                    id={`${this.prefix}_row_${row && row.GroupId}`}
                                    key={row.GroupId}
                                    style={{ visibility: this.state.dragDropRowGroupId && this.state.dragDropRowGroupId === this.props.questionTableItems[index].GroupId ? "hidden" : "visible" }}
                                    selected={this.props.selectedGroupIds.find(i => i === row.GroupId) !== undefined}
                                >
                                    {!this.props.readonly && this.state.questionTableItems.length > 1 &&
                                        <TableRowColumn
                                            id={`${this.prefix}_row_dragdrop_icon_${row && row.GroupId}`}
                                            style={{ paddingLeft: 3, paddingRight: 0, width: 25 }}
                                        >
                                            {!row.Child &&
                                                <div onClick={e => e.stopPropagation()}>
                                                    <ReOrder
                                                        style={{ width: 20, height: 20, paddingTop: 8 }}
                                                        onClick={() => this.setState({ dragDropRowGroupId: row.GroupId })}
                                                    />
                                                </div>
                                            }
                                        </TableRowColumn>
                                    }
                                    <TableRowColumn style={styles.orderCol}>{row.Child ? "C" : row.GroupId + 1}</TableRowColumn>
                                    <TableRowColumn style={styles.nameCol}>{row.Name}</TableRowColumn>
                                    <TableRowColumn style={styles.dateCol}>{row.ModifiedDate}</TableRowColumn>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                {this.state.dragDropRowGroupId !== null &&
                    <QuestionDragDropRow
                        prefix={this.prefix}
                        questionTableItems={this.state.questionTableItems.filter(i => !i.Child)}
                        dragDropRowGroupId={this.state.dragDropRowGroupId}
                        handleDrag={moveUp => {
                            const questionTableItems = this.state.questionTableItems
                            const dragDropItemIndexOf = questionTableItems.findIndex(item => item.GroupId === this.state.dragDropRowGroupId)
                            const otherItemGroupId = questionTableItems[dragDropItemIndexOf - moveUp].GroupId
                            const otherItemIndexOf = questionTableItems.findIndex(item => item.GroupId === otherItemGroupId)
                            const otherPT = questionTableItems[otherItemIndexOf]
                            questionTableItems[otherItemIndexOf] = questionTableItems[dragDropItemIndexOf]
                            questionTableItems[dragDropItemIndexOf] = otherPT
                            this.setState({ questionTableItems })
                        }}
                        handleDrop={() => {
                            this.setState({ dragDropRowGroupId: null })
                            this.props.handleReoderQuesetions(this.state.questionTableItems.map(i => i.GroupId))
                        }}
                    />
                }
            </div>
        )
    }
}

const styles = {
    orderCol: {
        paddingLeft: 5,
        paddingRight: 5,
        width: 40,
    },
    nameCol: {
        paddingLeft: 5,
        paddingRight: 5,
    },
    dateCol: {
        paddingLeft: 5,
        paddingRight: 5,
        width: 100
    }
}